// =============================================================================
// features/sales/campaigns/detail/CampaignDetailPage.tsx — Rota
// `/campanhas/:campaignId` (F35-S09, doc 26 §6.7).
//
// Gate de permissão + flag (mesmo padrão de CampaignsPage.tsx/OperatePage.tsx,
// F35-S07/F35-S10): `sales_campaigns:read` E `sales.campaigns.enabled`.
// Acesso direto à URL sem qualquer um dos dois mostra um estado PRÓPRIO
// desta página — nunca uma tela quebrada nem lista vazia (briefing do slot:
// "trate o 403 de forma visível"). `CampaignDetailContent` (que dispara a
// busca da campanha) só monta depois que os dois gates passam.
// =============================================================================

import * as React from 'react';
import { useParams } from 'react-router-dom';

import { useFeatureFlag } from '../../../../hooks/useFeatureFlag';
import { useAuth } from '../../../../lib/auth-store';

import { CampaignDetailContent } from './CampaignDetailContent';
import {
  CampaignDetailFlagDisabledState,
  CampaignDetailLoadingState,
  CampaignDetailMissingIdState,
  CampaignDetailNoPermissionState,
} from './CampaignDetailStates';

const FLAG_KEY = 'sales.campaigns.enabled';
const READ_PERMISSION = 'sales_campaigns:read';
const MANAGE_PERMISSION = 'sales_campaigns:manage';

export function CampaignDetailPage(): React.JSX.Element {
  const { campaignId } = useParams<{ campaignId: string }>();
  const { hasPermission } = useAuth();
  const { enabled: flagEnabled, isLoading: flagLoading } = useFeatureFlag(FLAG_KEY);

  const canRead = hasPermission(READ_PERMISSION);
  const canManage = hasPermission(MANAGE_PERMISSION);

  if (!campaignId) return <CampaignDetailMissingIdState />;
  if (!canRead) return <CampaignDetailNoPermissionState />;
  if (flagLoading) return <CampaignDetailLoadingState />;
  if (!flagEnabled) return <CampaignDetailFlagDisabledState flagKey={FLAG_KEY} />;

  return <CampaignDetailContent campaignId={campaignId} canManage={canManage} />;
}
